import { RESET_STORE } from '../../redux/store';
import {
  MY_REPOSSESSIONS_BASIC,
  MY_REPOSSESSIONS_LOADING,
  MY_SPOTTED_VEHICLES_BASIC,
  MY_SPOTTED_VEHICLES_LOADING,
  REPOSSESSIONS_FOR_BRANCH,
  REPOSSESSIONS_FOR_BRANCH_LOADING,
  REPOSSESSION_HIT_LIST_FOR_BRANCH,
  RHL_ASSIGNED_TO_ME_FULLFILLED,
  RHL_ASSIGNED_TO_ME_LOADING,
  SPOTTED_VEHICLES_FOR_BRANCH,
  SPOTTED_VEHICLES_FOR_BRANCH_LOADING,
  UNITS_PENDING_REPOSSESSIONS_FOR_BRANCH,
} from './events';

const INITIAL_STATE = {
  myRepossessions: {
    current: [],
    previous: [],
    previousTitle: '',
  },
  myRepossessionsLoading: false,
  mySpottedVehicles: {
    current: [],
    previous: [],
    previousTitle: '',
  },
  mySpottedVehiclesLoading: false,
  repossessionsForBranch: {
    current: [],
    previous: [],
    previousTitle: '',
  },
  repossessionsForBranchLoading: false,
  spottedVehiclesForBranch: {
    previous: [],
    current: [],
    previousTitle: '',
  },
  spottedVehiclesForBranchLoading: false,
  unitsPendingForBranch: {
    current: [],
    previous: [],
    previousTitle: '',
  },
  repossessionHitListForBranch: [],
  assignedToMe: {
    current: 0,
    previous: 0,
  },
  assignedToMeLoading: false,
};

export const basicDashboardReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case MY_REPOSSESSIONS_BASIC:
      return {
        ...state,
        myRepossessions: action.payload,
      };
    case MY_REPOSSESSIONS_LOADING:
      return {
        ...state,
        myRepossessionsLoading: action.payload,
      };
    case MY_SPOTTED_VEHICLES_BASIC:
      return {
        ...state,
        mySpottedVehicles: action.payload,
      };
    case MY_SPOTTED_VEHICLES_LOADING:
      return {
        ...state,
        mySpottedVehiclesLoading: action.payload,
      };
    case REPOSSESSIONS_FOR_BRANCH:
      return {
        ...state,
        repossessionsForBranch: action.payload,
      };
    case REPOSSESSIONS_FOR_BRANCH_LOADING:
      return {
        ...state,
        repossessionsForBranchLoading: action.payload,
      };
    case SPOTTED_VEHICLES_FOR_BRANCH:
      return {
        ...state,
        spottedVehiclesForBranch: action.payload,
      };
    case SPOTTED_VEHICLES_FOR_BRANCH_LOADING:
      return {
        ...state,
        spottedVehiclesForBranchLoading: action.payload,
      };
    case UNITS_PENDING_REPOSSESSIONS_FOR_BRANCH:
      return {
        ...state,
        unitsPendingForBranch: action.payload,
      };
    case REPOSSESSION_HIT_LIST_FOR_BRANCH:
      return {
        ...state,
        repossessionHitListForBranch: action.payload,
      };
    case RHL_ASSIGNED_TO_ME_FULLFILLED:
      return {
        ...state,
        assignedToMe: action.payload?.assignedToMe,
      };
    case RHL_ASSIGNED_TO_ME_LOADING:
      return {
        ...state,
        assignedToMeLoading: action.payload,
      };
    case RESET_STORE:
      return INITIAL_STATE;
    default:
      return state;
  }
};
